import WarningMessage from "./WarningMessage";
import './warningMessage.scss';

export default WarningMessage; 